import dayjs from "dayjs"

const hasExpired = (date) => {
  return dayjs().startOf('day').diff(date.startOf('day'), 'days') > 0
}

export default hasExpired